export const TESTS = {
    GDPR: 'ha_gdpr_banner',
    POLYFILL_SERVICE: 'HA_PTA_LANDING_PolyfillService',
    PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    SLP_TRAFFIC_TEST_AA: 'HA_PTA_LANDING_SLPTrafficTestAA',
    SLP_TOP_X_BEST_META_TITLE_TRAFFIC_TEST:
        'HA_PTA_LANDING_SLPTopXBestMetaTitleTrafficTest',
    BREADCRUMB_IN_HEADER: 'HA_PTA_LANDING_SLPReduceAndRepositionBreadcrumb',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    TRIPBOARDS_SAVE_LABEL: 'HA_PTA_LANDING_TripBoardsSaveLabel',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    DYNAMIC_RENDERING_2: 'HA_PTA_LANDING_DynamicRenderingIteration2',
    DYNAMIC_REFINEMENTS_MOBILE: 'Vrbo_landing_dynamicrefinementsmobiletabletV2', // 40217
    FAMILY_FRIENDLY_MODE: 'VRBO_LANDING_FamilyListingIteration2', // 40552
    PILL_FILTER_DESIGN: 'HA_PTA_Landing_Filterdesign',
    HA_PTA_LANDING_SLPHEROMAB: 'HA_PTA_LANDING_SLPHEROMAB', // 36217
    HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES:
        'HA_PTA_SEARCHBOX_hintTextChoosingDates', // 36021
    VRBO_LANDING_ARIARolesOnSearchForm: 'VRBO_LANDING_ARIArolesOnSearchForm', // 39457
    VRBO_LANDING_ColourContrastOnSearchForm:
        'VRBO_LANDING_colourContrastOnSearchForm', // 39456
    VRBO_LANDING_Scale_LaunchSearchFromGuestPicker:
        'VRBO_LANDING_scale_launchSearchFromGuestPicker', // 40617
    VRBO_LANDING_SCALE_HINT_TEXT_WHEN_CHOOSING_DATES:
        'VRBO_LANDING_scale_HintTextWhenChoosingDates', // 40753
    VRBO_LANDING_SLP_GLOBAL_MESSAGING_BANNER:
        'VRBO_LANDING_SLPGlobalMessagingBanner', // 40889
    VRBO_LANDING_SLP_BRANDED_HEADINGS: 'VRBO_LANDING_SLPBrandedHeadings', // 40981
    VRBO_LANDING_DESTINATIONLESS_ERROR_ON_SEARCHFORM:
        'VRBO_LANDING_DestinationlessErrorOnSearchForm', // 39471
    VRBO_LANDING_SEARCHFORM_DATE_FORMAT: 'VRBO_LANDING_searchFormDateFormat', // 40970,
    VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK:
        'VRBO_LANDING_searchFormDatepickerDayOfWeek', // 40979
    HEADING_CONVERSION: 'VRBO_LANDING_SLPHeadingConversionTestTemplate',
    HEADING_TRAFFIC: 'VRBO_LANDING_SLPHeadingTrafficTestTemplate',
    CONTENT_HUB_SLP: 'HA_PTA_LANDING_SLPContentHub',
    CONTENT_HUB_SLP_TRAFFIC: 'VRBO_LANDING_SLPContentHubTrafficTest',
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner',
    VRBO_WEB_GLOBAL_MESSAGING_ALERT: 'vrbo_web_global_messaging_alert', // 38174
    HA_PTA_SEARCHBOX_AddAgeOfChildren: 'HA_PTA_SEARCHBOX_addAgeOfChildren', // 36244
    HA_PTA_SEARCHFORM_DATES_NUMBER_OF_NIGHTS_SUMMARY:
        'HA_PTA_SEARCHFORM_datesnumberOfNightsSummary', // 36299
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
    USE_TCS_HERO: 'vrbo_landing_TCSforSLPHero', // 39167
    ROADTRIPS_SITE_NAVIGATION: 'VRBO_LANDING_RoadTripsSiteNavigation', // 38445
    ROADTRIPS_SITE_NAVIGATION_NEW_LABEL:
        'VRBO_LANDING_RoadTripsSiteNavigationNewLabel', // 40362
    VRBO_LANDING_SLPAA: 'Vrbo_landing_SLPAA', // 39889,
    DISCOVERY_SITE_NAVIGATION: 'HA_PTA_Landing_HPNavigationBar', // 35830
    DISCOVERY_SITE_NAVIGATION_NEW_LABEL:
        'HA_PTA_Landing_DiscoveryNavigationBarNewLabel', // 40792
    VRBO_LANDING_SLP_REMOVE_WEATHER_MODULE:
        'VRBO_LANDING_SLPRemoveWeatherModule', // 40634
    HA_PULSE_REMOVE_AUTO_SAVE: 'ha_pulse_remove_auto_save', // 40819
    SLP_REFINED_REMOVE_PROPERTY_TYPES_MODULE:
        'VRBO_LANDING_SLPRefinedRemovePropertyTypesModule', // 39765
    SLP_REFINED_REMOVE_PROPERTY_TYPES_MODULE_TRAFFIC:
        'VRBO_LANDING_SLPRefinedRemovePropertyTypesModuleTrafficTest', // 39766
    SLP_UNREFINED_REMOVE_PROPERTY_TYPES_MODULE:
        'VRBO_LANDING_SLPUnrefinedRemovePropertyTypesModule', // 40635
    SLP_UNREFINED_REMOVE_PROPERTY_TYPES_MODULE_TRAFFIC:
        'VRBO_LANDING_SLPUnrefinedRemovePropertyTypesModuleTrafficTest', // 40636
    SLP_UNREFINED_REMOVE_PRICING_INFOGRAPHIC_MODULE:
        'VRBO_LANDING_SLPRemovePricingModule', // 40637
    SLP_REMOVE_VALUE_PROPS_MODULE: 'VRBO_LANDING_SLPRemoveValuePropsModule', // 40638
    LANDING_UPDATE_POPULAR_DESTINATION:
        'VRBO_LANDING_Updatepopulardestinationmodule', // 40759
    HA_PULSE_SAVE_BUTTON_UPDATES: 'ha_pulse_save_button_updates', // 41072
    GRPC: 'VRBO_LANDING_grpc_migration', // 41060
};

export const EVALUATE = [
    TESTS.GDPR,
    TESTS.POLYFILL_SERVICE,
    TESTS.PRE_BRAND_TRANSITION,
    TESTS.POST_BRAND_TRANSITION,
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.HA_TYPEAHEAD_LID_SEARCH,
    TESTS.HA_TYPEAHEAD_TWO_LINE_DISPLAY,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.HA_PTA_HEADER_LOGIN_COPY,
    TESTS.DYNAMIC_RENDERING_2,
    TESTS.DYNAMIC_REFINEMENTS_MOBILE,
    TESTS.FAMILY_FRIENDLY_MODE,
    TESTS.PILL_FILTER_DESIGN,
    TESTS.HA_PTA_LANDING_SLPHEROMAB,
    TESTS.HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES,
    TESTS.VRBO_LANDING_ARIARolesOnSearchForm,
    TESTS.VRBO_LANDING_Scale_LaunchSearchFromGuestPicker,
    TESTS.VRBO_LANDING_SCALE_HINT_TEXT_WHEN_CHOOSING_DATES,
    TESTS.VRBO_LANDING_DESTINATIONLESS_ERROR_ON_SEARCHFORM,
    TESTS.VRBO_LANDING_ColourContrastOnSearchForm,
    TESTS.VRBO_LANDING_SLP_BRANDED_HEADINGS,
    TESTS.VRBO_LANDING_SLP_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_LANDING_SEARCHFORM_DATE_FORMAT,
    TESTS.VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK,
    TESTS.HEADING_CONVERSION,
    TESTS.CONTENT_HUB_SLP,
    TESTS.CONTENT_HUB_SLP_TRAFFIC,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT,
    TESTS.HA_PTA_SEARCHBOX_AddAgeOfChildren,
    TESTS.HA_PTA_SEARCHFORM_DATES_NUMBER_OF_NIGHTS_SUMMARY,
    TESTS.HA_TRAVELER_HEADER_TRAY_MOBILE_APP,
    TESTS.USE_TCS_HERO,
    TESTS.ROADTRIPS_SITE_NAVIGATION,
    TESTS.ROADTRIPS_SITE_NAVIGATION_NEW_LABEL,
    TESTS.VRBO_LANDING_SLPAA,
    TESTS.DISCOVERY_SITE_NAVIGATION,
    TESTS.DISCOVERY_SITE_NAVIGATION_NEW_LABEL,
    TESTS.VRBO_LANDING_SLP_REMOVE_WEATHER_MODULE,
    TESTS.HA_PULSE_REMOVE_AUTO_SAVE,
    TESTS.SLP_REFINED_REMOVE_PROPERTY_TYPES_MODULE,
    TESTS.SLP_UNREFINED_REMOVE_PROPERTY_TYPES_MODULE,
    TESTS.SLP_UNREFINED_REMOVE_PRICING_INFOGRAPHIC_MODULE,
    TESTS.LANDING_UPDATE_POPULAR_DESTINATION,
    TESTS.SLP_REMOVE_VALUE_PROPS_MODULE,
    TESTS.HA_PULSE_SAVE_BUTTON_UPDATES,
    TESTS.GRPC,
];

export const hasTest = (abacus, test) => !!(abacus && abacus[test]);

export const getValue = (abacus, test) => {
    const testExists = hasTest(abacus, test);
    if (!testExists) {
        console.warn(`requested value for non-existent test: ${test}`); // eslint-disable-line no-console
    }
    return testExists ? abacus[test].value : 0;
};
